import { sendAnalyticsEvent } from '~/lib/analytics.client';
import { AnalyticsAction } from '~/types/analytics';

export function navigateToStackblitzProject(slug: string, { clearSearch }: { clearSearch?: boolean } = {}) {
  /**
   * FIXME: Using the intended navigate function causes a rerender for <Chat /> that breaks the app.
   *
   * `navigate(`/~/${slug}`, { replace: true });`
   */
  const url = new URL(window.location.href);
  url.pathname = `/~/${slug}`;

  if (clearSearch) {
    url.search = '';
  } else {
    url.searchParams.delete('prompt');
  }

  window.history.replaceState({}, '', url);

  // since the `replaceState` call doesn't trigger a page reload, we need to manually log this event
  sendAnalyticsEvent({
    action: AnalyticsAction.Page,
    payload: {},
  });
}
